import * as React from 'react';
import { injectIntl } from 'react-intl';

import Button from '../../../components/button/Button';
import ButtonGroup from '../../../components/button-group/ButtonGroup';
import IconMinus from '../../../icons/general/IconMinusThin';
import IconPlus from '../../../icons/general/IconPlusThin';

import Field from './Field';
import messages from '../messages';

import './CustomField.scss';

var COLOR_999 = '#999';

var CustomField = function CustomField(_ref) {
    var intl = _ref.intl,
        canEdit = _ref.canEdit,
        isLast = _ref.isLast,
        dataKey = _ref.dataKey,
        dataValue = _ref.dataValue,
        onAdd = _ref.onAdd,
        onChange = _ref.onChange,
        onRemove = _ref.onRemove;

    var addBtn = React.createElement(
        Button,
        {
            'aria-label': intl.formatMessage(messages.customAdd),
            'data-resin-target': 'metadata-customfieldnew',
            type: 'button',
            onClick: onAdd
        },
        React.createElement(IconPlus, { color: COLOR_999 })
    );

    var removeBtn = React.createElement(
        Button,
        {
            'aria-label': intl.formatMessage(messages.customRemove),
            'data-resin-target': 'metadata-customfieldremove',
            type: 'button',
            onClick: function onClick() {
                if (onRemove) {
                    onRemove(dataKey);
                }
            }
        },
        React.createElement(IconMinus, { color: COLOR_999 })
    );

    return React.createElement(
        'div',
        { className: 'metadata-instance-editor-field-custom' },
        React.createElement(Field, {
            dataKey: dataKey,
            dataValue: dataValue,
            displayName: dataKey,
            canEdit: canEdit,
            onChange: onChange
            // Custom metadata doesn't allow removing of props if the value is emptied out, leave it as empty string
            , onRemove: function onRemove(key) {
                return onChange(key, '');
            },
            type: 'string'
        }),
        canEdit && React.createElement(
            'div',
            { className: 'metadata-instance-editor-field-custom-actions' },
            isLast ? React.createElement(
                ButtonGroup,
                null,
                removeBtn,
                addBtn
            ) : removeBtn
        )
    );
};

CustomField.propTypes = {
    dataKey: PropTypes.string.isRequired,
    dataValue: function dataValue() {
        return (typeof bpfrpt_proptype_FieldValue === 'function' ? bpfrpt_proptype_FieldValue.isRequired ? bpfrpt_proptype_FieldValue.isRequired : bpfrpt_proptype_FieldValue : PropTypes.shape(bpfrpt_proptype_FieldValue).isRequired).apply(this, arguments);
    },
    intl: function intl(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
            throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
        }
    },
    canEdit: PropTypes.bool.isRequired,
    isLast: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
};
export { CustomField as CustomFieldBase };
export default injectIntl(CustomField);
import { bpfrpt_proptype_FieldValue } from '../flowTypes';
import PropTypes from 'prop-types';